import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { Text } from '../Text';
var AgroCard = withCssProps(function (_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? 'agro-card' : _ref$alt,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$highlight = _ref.highlight,
    highlight = _ref$highlight === void 0 ? false : _ref$highlight,
    highlightTitle = _ref.highlightTitle,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? null : _ref$href,
    onCardClick = _ref.onCardClick,
    _ref$src = _ref.src,
    src = _ref$src === void 0 ? null : _ref$src,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'AgroCard' : _ref$title,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'vertical' : _ref$variant;
  var handleClick = function handleClick() {
    if (onCardClick) {
      onCardClick();
    }
  };
  var getCard = function getCard() {
    return /*#__PURE__*/React.createElement(CardContainer, null, highlight && /*#__PURE__*/React.createElement(HighLightTitleContainer, null, /*#__PURE__*/React.createElement(HighLightTitle, {
      color: "green500",
      type: "subtitle-sm"
    }, highlightTitle)), /*#__PURE__*/React.createElement(Card, {
      className: className,
      hasSrc: src && src.length,
      highlight: highlight,
      variant: variant,
      onMouseDown: function onMouseDown() {
        return handleClick();
      }
    }, src && /*#__PURE__*/React.createElement(ImgContainer, {
      variant: variant
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      variant: variant,
      src: src,
      alt: alt,
      title: title
    })), /*#__PURE__*/React.createElement(CardContent, {
      hasSrc: src && src.length,
      variant: variant
    }, children)));
  };
  return href ? /*#__PURE__*/React.createElement(Link, {
    href: href,
    title: title
  }, getCard()) : getCard();
});
AgroCard.propTypes = {
  alt: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  highlight: PropTypes.bool,
  highlightTitle: PropTypes.string,
  href: PropTypes.string,
  onCardClick: PropTypes.func,
  src: PropTypes.string,
  title: PropTypes.string,
  variant: PropTypes.oneOf(['vertical', 'horizontal'])
};
AgroCard.displayName = 'AgroCard';
export { AgroCard };
var BORDER_RADIUS = '16px';
var CardContainer = styled.div.withConfig({
  displayName: "AgroCard__CardContainer",
  componentId: "sc-51ysa2-0"
})(["display:flex;flex-direction:column;align-items:center;"]);
var HighLightTitleContainer = styled.div.withConfig({
  displayName: "AgroCard__HighLightTitleContainer",
  componentId: "sc-51ysa2-1"
})(["max-width:147px;box-sizing:border-box;padding:9px 16px;border:1px solid ", ";border-bottom:0;border-top-left-radius:", ";border-top-right-radius:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.green500;
}, BORDER_RADIUS, BORDER_RADIUS);
var HighLightTitle = styled(Text).withConfig({
  displayName: "AgroCard__HighLightTitle",
  componentId: "sc-51ysa2-2"
})(["display:block;max-width:147px;overflow:hidden;text-transform:uppercase;"]);
var Card = styled.div.withConfig({
  displayName: "AgroCard__Card",
  componentId: "sc-51ysa2-3"
})(["min-height:300px;width:100%;height:100%;display:flex;flex-direction:column;background:#ffffff;box-shadow:0px 3px 6px rgba(0,0,0,0.07);border-radius:", ";", ";", ";", ""], BORDER_RADIUS, function (_ref3) {
  var highlight = _ref3.highlight;
  return highlight && css(["border:", ";"], function (_ref4) {
    var theme = _ref4.theme;
    return "1px solid ".concat(theme.colors.green500);
  });
}, function (_ref5) {
  var variant = _ref5.variant;
  return variant === 'horizontal' && css(["min-height:220px;flex-direction:row;"]);
}, function (_ref6) {
  var hasSrc = _ref6.hasSrc;
  return hasSrc && css(["transition:all 0.3s ease;&:hover{box-shadow:0px 6px 10px rgba(0,0,0,0.15);}"]);
});
var Img = styled.img.withConfig({
  displayName: "AgroCard__Img",
  componentId: "sc-51ysa2-4"
})(["display:inline-block;-o-object-fit:cover;object-fit:cover;width:100%;height:100%;border-top-left-radius:", ";border-top-right-radius:", ";", ";"], BORDER_RADIUS, BORDER_RADIUS, function (_ref7) {
  var variant = _ref7.variant;
  return variant === 'horizontal' && css(["border-top-right-radius:0px;border-bottom-left-radius:", ";max-height:none;"], BORDER_RADIUS);
});
var ImgContainer = styled.div.withConfig({
  displayName: "AgroCard__ImgContainer",
  componentId: "sc-51ysa2-5"
})(["height:180px;", ";"], function (_ref8) {
  var variant = _ref8.variant;
  return variant === 'horizontal' && css(["height:auto;width:50%;"]);
});
var CardContent = styled.div.withConfig({
  displayName: "AgroCard__CardContent",
  componentId: "sc-51ysa2-6"
})(["flex-grow:1;position:relative;", ""], function (_ref9) {
  var hasSrc = _ref9.hasSrc,
    variant = _ref9.variant;
  return hasSrc && css(["", ";::before{content:'';border-top-left-radius:", ";border-top-right-radius:", ";position:absolute;top:-14px;width:100%;height:14px;background-color:white;", "}"], variant === 'horizontal' && css(["max-width:50%;"]), BORDER_RADIUS, BORDER_RADIUS, variant === 'horizontal' && css(["flex-grow:unset;border-top-left-radius:", ";border-bottom-left-radius:", ";border-top-right-radius:0px;top:0px;left:-14px;width:14px;height:100%;"], BORDER_RADIUS, BORDER_RADIUS));
});
var Link = styled.a.withConfig({
  displayName: "AgroCard__Link",
  componentId: "sc-51ysa2-7"
})(["cursor:pointer;color:inherit;text-decoration:inherit;font-weight:inherit;"]);